<template>
    <div id="productoverview">
        <div class="first-row">
            <ui5-label>{{ trans('pages.product_overview.sorting') }}</ui5-label>

            <ui5-select
                @change="filters.sortField = $event.detail.selectedOption.value"
            >
                <option
                    v-for="sortFieldOption in sortFieldOptions"
                    :key="sortFieldOption.value"
                    :selected="filters.sortField == sortFieldOption.value"
                    :value="sortFieldOption.value"
                >
                    {{ sortFieldOption.label }}
                </option>
            </ui5-select>

            <ui5-select
                @change="filters.sortOrder = $event.detail.selectedOption.value"
            >
                <option
                    v-for="sortOrderOption in sortOrderOptions"
                    :key="sortOrderOption.value"
                    :selected="filters.sortOrder == sortOrderOption.value"
                    :value="sortOrderOption.value"
                >
                    {{ sortOrderOption.label }}
                </option>
            </ui5-select>

            <ui5-button @click="applyFilters">
                {{ trans('pages.product_overview.sort_button') }}
            </ui5-button>

            <ui5-select
                @change="
                    filters.specialFilter = $event.detail.selectedOption.value
                "
            >
                <!-- productoverviewSpecialFilters -->
                <option
                    v-for="specialFilter in specialFilters"
                    :key="specialFilter.value"
                    :selected="filters.specialFilter == specialFilter.value"
                    :value="specialFilter.value"
                >
                    {{ specialFilter.label }}
                </option>
            </ui5-select>
        </div>

        <div class="filters">
            <span>
                <i
                    class="fa fa-shopping-cart fa-2x"
                    @click="showOrderForm"
                />
            </span>
            <ui5-input
                :placeholder="trans('pages.product_overview.product_number')"
                :value="filters.productnr"
                @input="filters.productnr = $event.target.value"
            />
            <ui5-input
                :placeholder="trans('pages.product_overview.order_number')"
                :value="filters.ordernr"
                @input="filters.ordernr = $event.target.value"
            />
            <ui5-input
                :placeholder="trans('pages.product_overview.customer')"
                :value="filters.customer"
                @input="filters.customer = $event.target.value"
            />
            <ui5-input
                :placeholder="trans('pages.product_overview.reference')"
                :value="filters.reference"
                @input="filters.reference = $event.target.value"
            />
            <auto-complete-input
                v-if="productTypeOptions"
                v-model="filters.producttype"
                :initial-search="
                    getLabel(filters.producttype, productTypeOptions)
                "
                :options="productTypeOptions"
                :placeholder="trans('pages.product_overview.product_type')"
            />
            <ui5-input
                :placeholder="trans('pages.product_overview.dimensions')"
                readonly="readonly"
                :value="filters.dimensions"
                @input="filters.dimensions = $event.target.value"
            />
            <div>
                <ui5-date-picker
                    :placeholder="
                        trans('pages.product_overview.production_date')
                    "
                    format-pattern="yyyy-MM-dd"
                    :value="filters.productionDate"
                    @change="filters.productionDate = $event.target.value"
                />
            </div>
            <ui5-input
                :placeholder="
                    trans('pages.product_overview.semifinished_ordered')
                "
                :value="filters.semifinishedOrdered"
                @input="filters.semifinishedOrdered = $event.target.value"
            />
            <ui5-input
                :placeholder="
                    trans('pages.product_overview.semifinished_delivered')
                "
                :value="filters.semifinishedDelivered"
                @input="filters.semifinishedDelivered = $event.target.value"
            />
            <span>
                <i
                    class="fa fa-filter fa-2x"
                    @click="applyFilters"
                />
            </span>
            <span>
                <i
                    class="fa fa-ban fa-2x"
                    @click="clearAndApplyFilters"
                />
            </span>
        </div>

        <ui5-table
            v-if="products"
            class="products-table no-header"
            growing="Button"
            :more-text="trans('pages.product_overview.load_more')"
            @load-more="loadMore"
        >
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />
            <ui5-table-column
                slot="columns"
                width="auto"
            />

            <ui5-table-row
                v-for="product in products"
                :key="product.productId"
            >
                <ui5-table-cell>
                    <div
                        @click="goToProductPage(product.productId)"
                        :style="{ backgroundColor: getColor(product) }"
                    >
                        <i class="fa fa-info-circle"></i>
                    </div>
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-checkbox
                        :checked="product.selected"
                        @change="product.selected = $event.target.checked"
                    />
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-input
                        type="Text"
                        :value="product.productNr"
                        readonly
                    />
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-input
                        type="Text"
                        :value="product.customerName"
                        readonly
                    />
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-input
                        type="Text"
                        :value="product.reference"
                        readonly
                    />
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-input
                        type="Text"
                        :value="product.producttypeName"
                        readonly
                    />
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-input
                        type="Text"
                        :value="product.dimensions"
                        readonly
                    />
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-date-picker
                        :value="product.productionDate"
                        readonly
                    />
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-input
                        type="Text"
                        :value="product.semifinishedOrdered"
                        readonly
                    />
                </ui5-table-cell>
                <ui5-table-cell>
                    <ui5-input
                        type="Text"
                        :value="product.semifinishedDelivered"
                        readonly
                    />
                </ui5-table-cell>
            </ui5-table-row>
        </ui5-table>

        <div
            id="spinner-container"
            v-if="loading"
        >
            <spinner id="spinner" />
        </div>

        <div>
            {{ trans('pages.product_overview.total_products_loaded') }}
            {{ products ? products.length : 0 }}
        </div>

        <ui5-popover
            id="order-form"
            :header-text="trans('pages.product_overview.order_form.title')"
            v-if="firstSelectedProduct"
        >
            <p>
                {{ trans('pages.product_overview.order_form.instruction') }}
                {{ firstSelectedProduct.productNr }}
            </p>
            <ui5-label>
                {{ trans('pages.product_overview.order_form.amount') }}
            </ui5-label>
            <text-input
                type="number"
                :placeholder="trans('pages.product_overview.order_form.amount')"
                v-model="orderAmount"
            />

            <div
                slot="footer"
                class="popover-footer"
            >
                <ui5-button
                    design="Emphasized"
                    @click="orderAction"
                >
                    {{ trans('pages.product_overview.order_form.confirm') }}
                </ui5-button>
                <!-- #ordersemifinishedaction -->
                <ui5-button @click="closeOrderForm">
                    {{ trans('pages.product_overview.order_form.cancel') }}
                </ui5-button>
                <!-- #cancelFinish -->
            </div>
        </ui5-popover>
    </div>
</template>
<script>
import orderApi from '../api/order';
import semiFinishedProductApi from '../api/semiFinishedProduct';
import {
    clearedFilters,
    sortFieldOptions,
    sortOrderOptions,
    specialFilters,
} from '../shared/semiFinishedProductOverview';
import { colorArray } from '../shared/colors';
import Spinner from '../components/loader/Spinner';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import AutoCompleteInput from '../components/AutoCompleteInput';
import { getLabel } from '../shared/collections';
import localization from '../mixins/localization';
import TextInput from '../components/TextInput';

export default {
    mixins: [NavigationFunctionsMixin, localization],
    components: { Spinner, AutoCompleteInput, TextInput },
    data() {
        return {
            orderAmount: '',
            loading: false,
            products: null,
            perPage: 50,
            productTypes: null,
            specialFilters: specialFilters,
            sortOrderOptions: sortOrderOptions,
            sortFieldOptions: sortFieldOptions,
            filters: { ...clearedFilters },
        };
    },
    computed: {
        payload() {
            return {
                ...this.filters,
                finished: 0, // Wordt niet gebruikt op deze pagina? ($('#productoverviewfilterfinished').is(':checked') ? 1 : 0);

                limit: this.perPage,
                offset: this.products ? this.products.length : 0,
                isNewVersion: true,
            };
        },
        firstSelectedProduct() {
            if (!this.products) {
                return null;
            }
            return this.products.filter((x) => x.selected)[0] || null;
        },
        selectedProductIds() {
            if (!this.products) {
                return [];
            }
            return this.products
                .filter((x) => x.selected)
                .map((x) => x.productId);
        },
        productTypeOptions() {
            if (!this.productTypes) {
                return null;
            }

            const options = this.productTypes.map((x) => {
                return { label: x.label, value: x.producttypeId };
            });

            options.unshift({
                label: '',
                value: null,
            });

            return options;
        },
    },
    methods: {
        getLabel,
        getColor(product) {
            const k = Math.min(Math.max(product.daysPastDue, 0), 9);
            return colorArray[k];
        },
        closeOrderForm() {
            window.document.querySelector('#order-form').close();
        },
        showOrderForm() {
            if (this.selectedProductIds.length == 0) {
                showInfoMessage(
                    this.trans(
                        'pages.product_overview.messages.select_parts_to_order'
                    )
                );
            } else {
                const btn = window.document.querySelector(
                    '#productoverview .filters i.fa-shopping-cart'
                );
                window.document.querySelector('#order-form').showAt(btn);
            }
        },
        orderAction() {
            if (!this.orderAmount.toString().length || this.orderAmount <= 0) {
                return showErrorMessage(
                    this.trans(
                        'pages.product_overview.messages.amount_must_be_positive'
                    )
                );
            }

            semiFinishedProductApi
                .orderPartsForSemifinishedProduct(
                    this.firstSelectedProduct.productId,
                    this.orderAmount
                )
                .then(() => {
                    this.firstSelectedProduct.selected = false;

                    if (!this.firstSelectedProduct) {
                        this.closeOrderForm();
                        this.applyFilters();
                    }
                });
        },
        applyFilters() {
            this.$store.commit(
                'semiFinishedProductOverview/setFilters',
                this.filters,
                { root: true }
            );
            this.products = null;
            this.loadMore();
        },
        clearAndApplyFilters() {
            this.filters = { ...clearedFilters };
            this.applyFilters();
        },
        loadMore() {
            this.loading = true;
            const payload = this.payload;
            semiFinishedProductApi
                .overviewSemifinishedProducts(payload)
                .then((response) => {
                    const products = response.data.data;
                    products.forEach((product) => {
                        product.selected = false;
                    });
                    if (!this.products) {
                        this.products = products;
                    } else {
                        this.products.push(...products);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.filters =
            this.$store.getters['semiFinishedProductOverview/getFilters'];

        this.loadMore();

        orderApi.productTypesForOrder().then((response) => {
            this.productTypes = response.data.data;
        });
    },
};
</script>
